import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";

/**
 * Update a paid combined catering order
 * @param {number} orderId - The order ID to update
 * @param {Object} orderData - The order data containing combine_order_id and combine_orders array
 * @returns {Promise} API response
 */
export const updateCombinedCateringPaidOrder = async (orderId, orderData) => {
  try {
    const response = await apiClient.post(
      `${API_ENDPOINTS.UPDATE_COMBINED_CATERING_PAID_ORDER}/${orderId}`,
      orderData
    );
    return response;
  } catch (error) {
    console.error("Error updating combined catering paid order:", error);
    throw error;
  }
};

